<template>
  <div>
    <va-card>
      <va-data-table
        :fields="fields"
        :data="rejectedOrders"
        :loading="loading"
        class="va-table va-table--hoverable va-table--clickable"
        api-mode
      >
        <template slot="id" slot-scope="props">
          <span>{{ props.rowData.id }}</span>
        </template>
        <template slot="name" slot-scope="props">
          <span>{{ props.rowData.order.name }}</span>
        </template>
        <template slot="total" slot-scope="props">
          <span>{{ props.rowData.order.amount_products }} р.</span>
        </template>
        <template slot="reason" slot-scope="props">
          <span>{{ props.rowData.note }}</span>
        </template>
        <template slot="phone" slot-scope="props">
          <span>{{ props.rowData.order.phone }}</span>
        </template>
        <template slot="actions" slot-scope="props">
          <va-button
            flat
            small
            color="info"
            @click.stop="approveOrder(props.rowData.id)"
          >
            Принять
          </va-button>

          <va-button
            flat
            small
            color="danger"
            @click.stop="disapproveOrder(props.rowData)"
          >
            Отменить
          </va-button>
        </template>
      </va-data-table>
    </va-card>
    <va-modal v-model="showApproveOrderModal" size="large" hide-default-actions>
      <order-disapprove-modal
        :order-info="currOrder"
        @updateList="$emit('updateList')"
        @hide="showApproveOrderModal = false"
      />
    </va-modal>
  </div>
</template>

<script>
import api from '@/api/axios';
import OrderDisapproveModal from './order-disapprove-modal.vue';
export default {
  name: 'RejectedOrdersTable',
  components: { OrderDisapproveModal },
  props: {
    rejectedOrders: {
      type: Array,
      require: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  data() {
    return {
      showOrderStatusModal: false,
      showApproveOrderModal: false,
      currOrder: {},
      term: null,
    };
  },
  computed: {
    fields() {
      return [
        {
          name: '__slot:id',
          title: '№',
        },
        {
          name: '__slot:name',
          title: 'Имя',
        },
        {
          name: '__slot:total',
          title: 'Сумма',
        },
        {
          name: '__slot:reason',
          title: 'Причина',
        },
        {
          name: '__slot:phone',
          title: 'Телефон',
        },
        {
          name: '__slot:actions',
          title: '',
        },
      ];
    },
    getOrders() {
      if (!this.term || this.term.length < 1) {
        return this.orders;
      }
      return this.orders.filter((item) => {
        return item.name.toLowerCase().includes(this.term.toLowerCase());
      });
    },
  },

  methods: {
    async approveOrder(productId) {
      try {
        await api
          .post(`/admin/order-reject-requests/${productId}/approve`)
          .then((res) => {
            alert(res.data.message);
            this.$emit('updateList');
          });
      } catch (error) {
        return error;
      }
    },
    disapproveOrder(orderInfo) {
      this.currOrder = orderInfo;
      this.showApproveOrderModal = true;
    },
  },
};
</script>

<style lang="scss">
.data-table-server-pagination---avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
@import 'src/assets/scss/components/tooltip.scss';
</style>
<style lang="scss" scoped>
.success,
.warning,
.danger,
.primary {
  border-radius: 11px;
  padding: 5px;
}
.success {
  background-color: #4bb543;
  color: #fff;
}
.warning {
  background-color: #f2f236;
  color: #000;
}
.danger {
  background-color: #df4759;
  color: #fff;
}
.primary {
  background-color: #0275d8;
  color: rgb(255, 255, 255);
}
</style>
